<div class="signs3_SingleSign_Contianer txtBlkShadow">
   
<div class="zodiacMainIcon BOS iconBlkGlow">
{{preDayIcon}}
</div>
<div class="signIcons BOS">
    {{preElement}} {{preQuality}} {{preGlyph}} {{preHouse}} {{prePlanet}}
</div>
<div class="signName">
<button (click)="prevSign()" class="buttonTxt" [style.background-color]="preColor ? 'rgb(' + preColor + ')' : 'unset'" mat-raised-button>{{preSignName}}</button>
</div>
</div>
<div class="signs3_SingleSign_Contianer txtBlkShadow centerCuspText">
    <p class="BOS sunCuspsize">N</p>
     <p>The sun is in a cusp transition from <br><strong>{{preSignName}}</strong> to <strong>{{postSignName}}</strong> </p></div>

<div class="signs3_SingleSign_Contianer txtBlkShadow">


    <div class="zodiacMainIcon BOS iconBlkGlow">
    {{postDayIcon}}
    </div>
    <div class="signIcons BOS">
        {{postElement}} {{postQuality}} {{postGlyph}} {{postHouse}} {{postPlanet}}
    </div>
    <div class="signName">
    <button (click)="postSign()" class="buttonTxt" [style.background-color]="postColor ? 'rgb(' + postColor + ')' : 'unset'" mat-raised-button>{{postSignName}}</button>
    </div>
</div>


<!-- <div class="centerContainer centerTxt">
    <div class="inline">
      <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
    </div>
  
    <div class="inline txtBlkShadow">
      <p>Today is</p>
      <p class="monthName">{{ weekdayIs }} {{ monthIs }} {{ dayIs }}, 2021</p>
    </div>
  
    <div class="inline">
      <button (click)="nextMonth()" mat-raised-button>Next Month</button>
    </div>
  </div> -->
  <div class="mobile1-3">
    <div class="centerContainer centerTxt">
      
      <div class="inline txtBlkShadow">
        <p>Today is</p>
        <p class="monthName">{{ weekdayIs }} {{ monthIs }} {{ dayIs }}, 2022</p>
      </div>
    </div>
    
    <div class="centerContainer centerTxt">
      <div class="inline">
        <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
      </div>
    
      <div class="inline">
        <button (click)="nextMonth()" mat-raised-button>Next Month</button>
      </div>
    </div>
    </div>
    
    <div class="mobile4-retina">
    <div class="centerContainer centerTxt">
      
      <div class="inline">
        <button (click)="prevMonth()" mat-raised-button>Prev Month</button>
      </div>
    
      <div class="inline txtBlkShadow">
        <p>Today is</p>
        <p class="monthName">{{ weekdayIs }} {{ monthIs }} {{ dayIs }}, 2022</p>
      </div>
    
      <div class="inline">
        <button (click)="nextMonth()" mat-raised-button>Next Month</button>
      </div>
    </div>
    </div>